/**
 * Tender Source Catalog — WO-32.
 *
 * Two ways tenders reach Mid2Bid, and only two:
 *   - "server"    → the Mid2Bid server reads the portal's public list itself.
 *                   Only for portals that allow it and answer servers outside
 *                   the Gulf. One button: "Refresh server sources".
 *   - "collector" → an admin reads the portal's public list in their own Chrome
 *                   with the Mid2Bid Collector add-on and presses Import.
 *
 * Checked 21/09/2026 from a Saudi connection: every portal below shows its list
 * publicly, with no login.
 */

export const RETRIEVAL_METHODS = {
  server: {
    label: 'Server',
    description: 'Mid2Bid reads this portal by itself when an admin presses "Refresh server sources".',
    badgeCls: 'bg-emerald-500/10 text-emerald-700 dark:text-emerald-400 border-emerald-500/30',
  },
  collector: {
    label: 'Collector add-on',
    description: 'An admin opens the portal in Chrome and imports its public list with the Mid2Bid Collector add-on.',
    badgeCls: 'bg-sky-500/10 text-sky-700 dark:text-sky-400 border-sky-500/30',
  },
};

// `name` is the value stored in tenders.source. `pages` says how the add-on reads it:
// "auto" = it reads the following pages by itself; "screen" = only the page on screen
// (the portal's robots.txt asks programs not to fetch its pages).
export const TENDER_SOURCES = [
  { key: 'abudhabi', name: 'Abu Dhabi ADGPG', country: 'AE', flag: '🇦🇪', method: 'server', url: 'https://www.adgpg.gov.ae/en/For-Suppliers/Public-Tenders' },
  { key: 'bahrain', name: 'Bahrain Tender Board', country: 'BH', flag: '🇧🇭', method: 'server', url: 'https://www.tenderboard.gov.bh/Tenders/PublicTenders/' },
  { key: 'ashghal', name: 'Qatar Ashghal', country: 'QA', flag: '🇶🇦', method: 'server', url: 'https://www.ashghal.gov.qa/en/Tenders/Pages/erptenders.aspx' },

  { key: 'etimad', name: 'Etimad', country: 'SA', flag: '🇸🇦', method: 'collector', pages: 'auto', url: 'https://tenders.etimad.sa/Tender/AllTendersForVisitor' },
  { key: 'muqawil', name: 'Muqawil', country: 'SA', flag: '🇸🇦', method: 'collector', pages: 'auto', url: 'https://www.muqawil.org/en/market/list?status=new&created_at=720', note: 'Private projects' },
  { key: 'monaqasat', name: 'Qatar Monaqasat', country: 'QA', flag: '🇶🇦', method: 'collector', pages: 'auto', url: 'https://monaqasat.mof.gov.qa/TendersOnlineServices/AvailableMinistriesTenders/1' },
  { key: 'kuwait', name: 'Kuwait CAPT', country: 'KW', flag: '🇰🇼', method: 'collector', pages: 'auto', url: 'https://capt.gov.kw/en/tenders/opening-tenders/' },
  { key: 'oman', name: 'Oman Tender Board', country: 'OM', flag: '🇴🇲', method: 'collector', pages: 'auto', url: 'https://etendering.tenderboard.gov.om/product/publicDash?viewFlag=NewTenders' },
  { key: 'dubai', name: 'Dubai eSupply', country: 'AE', flag: '🇦🇪', method: 'collector', pages: 'screen', url: 'https://esupply.dubai.gov.ae/esop/guest/go/public/opportunity/current' },
  { key: 'sharjah', name: 'Sharjah eProcurement', country: 'AE', flag: '🇦🇪', method: 'collector', pages: 'screen', url: 'https://www.eprocurement.sfd.gov.ae/esop/guest/go/public/opportunity/current?locale=en_GB' },
  { key: 'uae_federal', name: 'UAE Federal Procurement', country: 'AE', flag: '🇦🇪', method: 'collector', pages: 'screen', url: 'https://procurement.gov.ae/page.aspx/en/rfp/request_browse_public' },
];

export const SERVER_SOURCE_KEYS = TENDER_SOURCES.filter((s) => s.method === 'server').map((s) => s.key);

// The Mid2Bid Collector add-on's fixed Chrome id (set by the "key" in its manifest).
// The Tender Sources page uses it to hand the collector key straight to the add-on.
export const COLLECTOR_EXTENSION_ID = 'cknacepmgonokhmnhfdkifieiapgjcbo';
